import { PortalGradientColor, PortalSolidColor } from '@nx-frontend/shared/types';
import { capitalize } from '@nx-frontend/shared/utils';
import { undash } from '@nx-frontend/shared/utils/text-utils';

interface getColorNameProps {
  color: PortalSolidColor | PortalGradientColor;
  prefix?: string;
  forceGradient?: boolean;
}

export const getColorName = ({ color }: getColorNameProps): string => {
  if (typeof color[1] !== 'string') {
    return capitalize(undash(color[0]));
  }
  return `From ${capitalize(undash(color[0]))} to ${capitalize(undash(color[1]))}`;
};
